import React, { useState, useEffect, ReactNode } from 'react';
import tw from 'tailwind-styled-components';
import styled from 'styled-components';

const DownArrows = tw.div`
  md:w-20
  md:h-20
  w-14
  w-14
  m-auto
  float-right
  ml-3
  z-30
`;

const DownArrowsMain = tw.div`
  fixed
  w-auto
  m-auto
  cursor-pointer
  bottom-8
  md:right-uparrow
  right-uparrow-21
  inline-block align-middle
  z-60
`;

const ArrowContainer = styled.button<{
  children?: ReactNode;
  'data-test'?: string;
  'data-print'?: string;
}>`
  width: 54px;
  height: 54px;
  background-image: url("data:image/svg+xml, %3Csvg aria-hidden='true' width='54' height='54' viewBox='0 0 54 54' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Ccircle cx='27' cy='27' r='27' transform='rotate(-180 27 27)' fill='%23010E54' /%3E%3Cpath d='M27.0001 35C27.0001 35 27.0001 24.6437 27.0001 19M27.0001 19C27.0001 21.5806 24.6315 24.6774 22 24.6774M27.0001 19C27.0001 21.5806 29.3684 24.6774 32 24.6774' stroke='white' strokeLinecap='square' /%3E%3Cpath d='M30.0249 47.9094C28.1894 49.1181 25.8106 49.1181 23.9751 47.9094L23.5862 47.6533C22.4161 46.8827 21.0284 46.5109 19.6297 46.5932L19.165 46.6205C16.971 46.7495 14.9109 45.5601 13.9257 43.5956L13.4787 43.8197L13.9257 43.5956L13.7169 43.1794C13.0889 41.927 12.073 40.9111 10.8206 40.283L10.4044 40.0743C8.4399 39.0891 7.25048 37.029 7.37951 34.835L7.40684 34.3702C7.4891 32.9716 7.11725 31.5839 6.3467 30.4138L6.09063 30.0249C4.88193 28.1894 4.88193 25.8106 6.09063 23.9751L6.3467 23.5862C7.11725 22.4161 7.4891 21.0284 7.40684 19.6297L7.37951 19.165C7.25048 16.971 8.4399 14.9109 10.4044 13.9257L10.8206 13.7169C12.073 13.0889 13.0889 12.073 13.717 10.8206L13.9257 10.4044C14.9109 8.43989 16.971 7.25048 19.165 7.3795L19.6297 7.40684C21.0284 7.48909 22.4161 7.11724 23.5862 6.3467L23.9751 6.09063C25.8106 4.88192 28.1894 4.88192 30.0249 6.09063L30.4138 6.3467C31.5839 7.11724 32.9716 7.48909 34.3702 7.40684L34.835 7.3795C37.029 7.25048 39.0891 8.43989 40.0743 10.4044L40.283 10.8206C40.9111 12.073 41.927 13.0889 43.1794 13.7169L43.5956 13.9257C45.5601 14.9109 46.7495 16.971 46.6205 19.165L46.5932 19.6297C46.5109 21.0284 46.8828 22.4161 47.6533 23.5862L47.9094 23.9751C49.1181 25.8106 49.1181 28.1894 47.9094 30.0249L47.6533 30.4138C46.8828 31.5839 46.5109 32.9716 46.5932 34.3702L46.6205 34.835C46.7495 37.029 45.5601 39.0891 43.5956 40.0743L43.1794 40.283C41.927 40.9111 40.9111 41.927 40.283 43.1794L40.0743 43.5956C39.0891 45.5601 37.029 46.7495 34.835 46.6205L34.3702 46.5932C32.9716 46.5109 31.5839 46.8827 30.4138 47.6533L30.0249 47.9094Z' stroke='white' strokeLinejoin='round' /%3E%3C/svg%3E%0A");
  @media (min-width: 768px) {
    width: 84px;
    height: 84px;
    background-image: url("data:image/svg+xml, %3Csvg aria-hidden='true' width='84' height='84' viewBox='0 0 84 84' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Ccircle cx='42.001' cy='42' r='42' transform='rotate(-180 42.001 42)' fill='%23010E54' /%3E%3Cpath d='M42.0011 54.4453C42.0011 54.4453 42.0011 38.3355 42.0011 29.5564M42.0011 29.5564C42.0011 33.5708 38.3165 38.388 34.2231 38.388M42.0011 29.5564C42.0011 33.5708 45.6851 38.388 49.7787 38.388' stroke='white' strokeWidth='2' strokeLinecap='square' /%3E%3Cpath d='M44.7505 75.5465C43.0819 76.6453 40.9193 76.6453 39.2507 75.5465L35.8883 73.3323C34.6282 72.5024 33.1337 72.102 31.6275 72.1906L27.6084 72.4269C25.6139 72.5442 23.7411 71.4629 22.8454 69.677L21.0406 66.0783C20.3642 64.7295 19.2702 63.6355 17.9215 62.9591L14.3227 61.1543C12.5368 60.2586 11.4555 58.3858 11.5728 56.3913L11.8092 52.3723C11.8977 50.8661 11.4973 49.3716 10.6675 48.1114L8.45326 44.749C7.35444 43.0804 7.35444 40.9178 8.45326 39.2492L10.6675 35.8868C11.4973 34.6267 11.8977 33.1322 11.8092 31.626L11.5728 27.6069C11.4555 25.6125 12.5368 23.7396 14.3227 22.844L17.9215 21.0391C19.2702 20.3628 20.3642 19.2687 21.0406 17.92L22.8454 14.3212C23.7411 12.5353 25.6139 11.454 27.6084 11.5713L31.6275 11.8077C33.1337 11.8963 34.6282 11.4958 35.8883 10.666L39.2507 8.45179C40.9193 7.35297 43.0819 7.35297 44.7505 8.45179L48.1129 10.666C49.373 11.4958 50.8675 11.8963 52.3737 11.8077L56.3928 11.5713C58.3873 11.454 60.2601 12.5353 61.1558 14.3212L62.9606 17.92C63.637 19.2687 64.731 20.3628 66.0797 21.0391L69.6785 22.844C71.4644 23.7396 72.5457 25.6125 72.4284 27.6069L72.192 31.626C72.1034 33.1322 72.5039 34.6267 73.3337 35.8868L75.5479 39.2492C76.6468 40.9178 76.6468 43.0804 75.5479 44.749L73.3337 48.1114C72.5039 49.3716 72.1034 50.8661 72.192 52.3723L72.4284 56.3913C72.5457 58.3858 71.4644 60.2586 69.6785 61.1543L66.0797 62.9591C64.731 63.6355 63.637 64.7296 62.9606 66.0783L61.1558 69.677C60.2601 71.4629 58.3872 72.5442 56.3928 72.4269L52.3737 72.1906C50.8675 72.102 49.373 72.5024 48.1129 73.3323L44.7505 75.5465Z' stroke='white' strokeWidth='2' strokeLinejoin='round' /%3E%3C/svg%3E%0A");
  }
`;

const CorpArrowContainer = styled.button<{
  children?: ReactNode;
  'data-test'?: string;
  'data-print'?: string;
}>`
  width: 54px;
  height: 54px;
  background-image: url("data:image/svg+xml, %3Csvg width='54' height='54' viewBox='0 0 84 84' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='42' cy='42' r='42' fill='%23010E54'/%3E%3Cpath d='M42.0006 54.4453C42.0006 54.4453 42.0006 38.3355 42.0006 29.5564M42.0006 29.5564C42.0006 33.5708 38.316 38.388 34.2227 38.388M42.0006 29.5564C42.0006 33.5708 45.6846 38.388 49.7782 38.388' stroke='%23E6E7EE' stroke-width='2' stroke-linecap='square'/%3E%3Ccircle cx='42' cy='42' r='35' stroke='%23E6E7EE' stroke-width='2'/%3E%3C/svg%3E%0A");
  @media (min-width: 768px) {
    width: 84px;
    height: 84px;
    background-image: url("data:image/svg+xml, %3Csvg width='84' height='84' viewBox='0 0 84 84' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='42' cy='42' r='42' fill='%23010E54'/%3E%3Cpath d='M42.0006 54.4453C42.0006 54.4453 42.0006 38.3355 42.0006 29.5564M42.0006 29.5564C42.0006 33.5708 38.316 38.388 34.2227 38.388M42.0006 29.5564C42.0006 33.5708 45.6846 38.388 49.7782 38.388' stroke='%23E6E7EE' stroke-width='2' stroke-linecap='square'/%3E%3Ccircle cx='42' cy='42' r='35' stroke='%23E6E7EE' stroke-width='2'/%3E%3C/svg%3E%0A");
  }
`;

const ScrollTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

export const UpArrow = ({ isCorporate }: { isCorporate?: boolean }) => {
  const [opacity, setOpacity] = useState<number>(1);

  const handleScroll = () => {
    const opacityLevel = window.scrollY > 1000 ? 1 : 0;
    setOpacity(opacityLevel);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const Container = isCorporate ? CorpArrowContainer : ArrowContainer;

  return (
    <DownArrowsMain
      data-test="down-arrows-main"
      style={{ opacity: `${opacity}` }}
      onClick={ScrollTop}
      data-print="hide"
    >
      <DownArrows>
        <Container data-test="arrow-desktop" data-print="hide">
          <span className="sr-only">Scroll to top</span>
        </Container>
      </DownArrows>
    </DownArrowsMain>
  );
};
